import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class EmergencyContactValidator {
    /**
     * Validates that if emergency contacts are provided, at least one contact has:
     * - A name (required)
     * - Either a mobile number or email address (at least one required)
     */
    static validateEmergencyContacts(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const hasEmergencyContact = control.get('hasEmergencyContact')?.value;
            
            // If user chose not to provide emergency contacts, validation passes
            if (hasEmergencyContact === false) {
                return null;
            }
            
            // If user hasn't made a choice yet, validation passes (will be handled by required validation)
            if (hasEmergencyContact === null) {
                return null;
            }
            
            // If user chose to provide emergency contacts, validate the details
            if (hasEmergencyContact === true) {
                const emergencyContact = control.get('emergencyContact')?.value;
                const emergencyContactMobile = control.get('emergencyContactMobile')?.value;
                const emergencyContactEmail = control.get('emergencyContactEmail')?.value;
                
                const emergencyContact2 = control.get('emergencyContact2')?.value;
                const emergencyContactMobile2 = control.get('emergencyContactMobile2')?.value;
                const emergencyContactEmail2 = control.get('emergencyContactEmail2')?.value;
                
                // Check if at least one emergency contact has required information
                const primaryContactValid = this.isContactValid(emergencyContact, emergencyContactMobile, emergencyContactEmail);
                const secondaryContactValid = this.isContactValid(emergencyContact2, emergencyContactMobile2, emergencyContactEmail2);
                
                if (!primaryContactValid && !secondaryContactValid) {
                    return {
                        emergencyContactRequired: {
                            message: 'At least one emergency contact must have a name and either a mobile number or email address.'
                        }
                    };
                }
            }
            
            return null;
        };
    }
    
    /**
     * Validates a single emergency contact
     * @param name The contact's name
     * @param mobile The contact's mobile number
     * @param email The contact's email address
     * @returns true if the contact is valid (has name and either mobile or email)
     */
    private static isContactValid(name: any, mobile: any, email: any): boolean {
        // Name is required
        if (!name || String(name).trim() === '') {
            return false;
        }
        
        // Either mobile or email is required
        const hasMobile = mobile && String(mobile).trim() !== '';
        const hasEmail = email && String(email).trim() !== '';
        
        return hasMobile || hasEmail;
    }
} 